import { Flex } from 'antd';
import { Title } from 'components/mvp-typography';
import { usePatientInfoContext } from 'features/patient/_utils/patient-info/hook-context-patientinfo';
import { brainFunctionCategories } from 'lib/utils/business/brainfunction-categories';
import { BrainFunctionCategoryComponent } from './components/brainfunction-category-display';

export function DisplayBrainfunctionCategories() {
  const patientInfo = usePatientInfoContext();
  return (
    <div>
      <Title level={2}>Functional Overview</Title>
      <Flex gap={'large'} vertical>
        {brainFunctionCategories.map((_, i) => (
          <>
            {/* <Card> */}
            <BrainFunctionCategoryComponent
              key={i}
              category={_}
              visualisationData={patientInfo.patientInfo}
            />
            {/* </Card> */}
            <hr
              style={{
                width: '70%',
                borderTop: 0,
                borderColor: '#33333340'
              }}
            />
          </>
        ))}
      </Flex>
    </div>
  );
}
